"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIGH_OBFUSCATION_PRESET = void 0;
const OptionsPreset_1 = require("../../enums/options/presets/OptionsPreset");
const StringArrayEncoding_1 = require("../../enums/node-transformers/string-array-transformers/StringArrayEncoding");
const MediumObfuscation_1 = require("./MediumObfuscation");
exports.HIGH_OBFUSCATION_PRESET = Object.freeze({
    ...MediumObfuscation_1.MEDIUM_OBFUSCATION_PRESET,
    controlFlowFlatteningThreshold: 1,
    deadCodeInjectionThreshold: 1,
    debugProtection: true,
    debugProtectionInterval: true,
    optionsPreset: OptionsPreset_1.OptionsPreset.HighObfuscation,
    splitStringsChunkLength: 5,
    stringArrayEncoding: [
        StringArrayEncoding_1.StringArrayEncoding.Rc4
    ],
    stringArrayWrappersCount: 5,
    stringArrayWrappersParametersMaxCount: 5,
    stringArrayThreshold: 1
});
